export const SETUP_CONFIG_REQUEST = "SETUP_CONFIG_REQUEST";
export const SETUP_CONFIG_FETCH_SUCCESS = "SETUP_CONFIG_FETCH_SUCCESS";
export const SETUP_CONFIG_SAVE_SUCCESS = "SETUP_CONFIG_SAVE_SUCCESS";
export const SETUP_CONFIG_VALIDATION_ERROR = "SETUP_CONFIG_VALIDATION_ERROR";
export const HIDE_SETUP_CONFIG_FIELD_VALIDATION_ERROR =
  "HIDE_SETUP_CONFIG_FIELD_VALIDATION_ERROR";
